var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.00019C0.447715 7.00019 4.82823e-08 7.44791 0 8.00019C-4.82823e-08 8.55247 0.447715 9.00019 1 9.00019V7.00019ZM17.7071 8.7073C18.0976 8.31677 18.0976 7.68361 17.7071 7.29308L11.3431 0.929123C10.9526 0.538599 10.3195 0.538599 9.92893 0.929123C9.53841 1.31965 9.53841 1.95281 9.92893 2.34334L15.5858 8.00019L9.92893 13.6571C9.53841 14.0476 9.53841 14.6807 9.92893 15.0713C10.3195 15.4618 10.9526 15.4618 11.3431 15.0713L17.7071 8.7073ZM1 9.00019H17V7.00019H1V9.00019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrow);
export default __webpack_public_path__ + "static/media/warrow.4435590084604c152f79eb18ce8c6821.svg";
export { ForwardRef as ReactComponent };